import React from 'react'
import PropTypes from 'prop-types'

import style from './style'

const DefaultContentComponent = ({ id, children, layout }) => (
  <article id={id} className={style('base-layout', layout)}>
    {children}
  </article>
)
DefaultContentComponent.propTypes = {
  id: PropTypes.string.isRequired,
  layout: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
}

export default DefaultContentComponent
